const enrichUserWithLead = (capId, variation = 'ALT') => {
  if (window.lcTracking && window.lcTracking.tracking) {
    const data = window.lcTracking.data || { userProps: {} };
    const trackingData = Object.assign(data, {});
    trackingData.userProps.PF_EREG_EXP = variation;
    window.lcTracking.tracking.identify(capId);
    window.lcTracking.tracking.enrichEventsForUser(trackingData.userProps);
  }
};

export default enrichUserWithLead;

